module.exports = __webpack_public_path__ + "static/media/3.6a3e0c1b.jpg";